/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-08-30 15:16:29
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2024-09-09 10:35:10
 * @FilePath: \crane-safety-manager\src\Common\VehicleListModel.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import _ from 'lodash';
import { Modal, Empty, Table, Typography } from 'antd';
import React, { useState } from 'react';

const { Link } = Typography;

const VehicleListModel = ({title,cardType,visible,data,close}) => {

  let countList = data.length > 0 ? data.sort((a, b) => b.LCount - a.LCount) : [];
  countList.forEach((item, index) => {
      item.index = index + 1;
  });
  // let countList = _.entries(data).map(x => ({ name: x[0], value: x[1] }));
  // countList = _.orderBy(countList, ['value', 'name'], ['desc', 'asc']);
  // const topList = countList.map((item,i) => (
  //     <li key={item.name} className='card-list-li'>
  //         <div style={{ display: 'flex', justifyContent:'space-between' }}>
  //             <span>
  //                 <span style={{ margin: '0.5em' }}>{i + 1}.</span>
  //                 <span>{item.name}</span>
  //             </span>{' '}                    
  //             <b style={{ marginRight: '0.5em' }}>{item.value}</b>
  //         </div>
  //     </li>
  // ));
  const tableColumns = [
    {
        title: '序号',
        dataIndex: 'index',
        align:'center',
        width: 80,
    },
    {
        title: '车辆名称',
        // dataIndex: 'name',
        align:'center',
        render: item => <Link href={`/vehicles/${item.id}?tab=location`}>{item.name}</Link>,
    },
    {
      title: cardType === 'AlarmsCount' ? '次数' :
        cardType === 'DailyOnline' ? '时长(h)' :
          cardType === 'AbnormalStart' ? '次数' :
            '数据',
      dataIndex: 'LCount',
      align:'center',
      render: (text, record) => {
        if (cardType === 'DailyOnline') {
          return (text / 60).toFixed(2);
        }else{
          return text;
        }
      }
    },
  ];
  const pagination = {
    defaultPageSize: 5, // 默认的页大小
  };

  const EmptyItem = <Empty image="/nodata.png" description={<span></span>} style={{ padding: '10%' }} />;
  return (
    <>
      <Modal title={title} footer={null} open={visible} onCancel={close} wrapClassName="custom-modal-body">
        {/* {topList && topList.length > 0 ? <ul style={{ listStyleType: 'none', padding: 0, height: "15em", overflowY: 'auto' }}>{topList}</ul> : EmptyItem} */}
        <React.Fragment>
            {countList && countList.length > 0 ? (
                <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                    <Table className='table-list transparent-table' rowKey="id" columns={tableColumns} dataSource={countList} pagination={pagination} scroll={{y:'calc(100vh - 408px)'}}/>
                </div>
            ) : (
                <Empty image="/nodata.png" description={<span></span>} style={{ padding: '10%' }}></Empty>
            )}
        </React.Fragment>
      </Modal>
    </>
  );
};

export default VehicleListModel;